import { createContext, useContext, useState } from 'react'

class SideBySideChart {
  constructor ({ chartMirrorState }) {
    const [ chartMirrorData, setChartMirrorData ] = chartMirrorState
    this.chartMirrorData = chartMirrorData
    this.setChartMirrorData = setChartMirrorData
  }

  getChartMirrorData () {
    return this.chartMirrorData
  }

  setChartMirrorDataValue (key, data) {
    this.setChartMirrorData({ ...this.chartMirrorData, [key]: data })
  }

  clearChartMirrorDataValue (key) {
    const chartMirrorData = { ...this.chartMirrorData }
    delete chartMirrorData[key]
    this.setChartMirrorData(chartMirrorData)
  }
}

const SideBySideChartContext = createContext()

export const useSideBySideChartContext = function () {
  return useContext(SideBySideChartContext)
}

export const SideBySideChartContextProvider = function ({ children }) {
  const chartMirrorState = useState({})
  const chart = new SideBySideChart({ chartMirrorState })

  return (
    <SideBySideChartContext.Provider value={chart}>
      {children}
    </SideBySideChartContext.Provider>
  )
}
